import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "cs-app" }
const _hoisted_2 = {
  key: 0,
  class: "modal-form modal-form-show"
}
const _hoisted_3 = {
  key: 1,
  class: "modal-form modal-form-show"
}
const _hoisted_4 = {
  key: 2,
  class: "modal-form modal-form-show"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"loader-boxs\"><div class=\"scene\"><div class=\"plane\"><div class=\"cube cube--0\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--0\"></div><div class=\"cube cube--1\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--1\"></div><div class=\"cube cube--2\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--2\"></div><div class=\"cube cube--3\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--3\"></div><div class=\"cube cube--4\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--4\"></div><div class=\"cube cube--5\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--5\"></div><div class=\"cube cube--6\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--6\"></div><div class=\"cube cube--7\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--7\"></div></div></div></div>", 1)
const _hoisted_6 = [
  _hoisted_5
]

import { watch, ref } from "vue";
import { storeToRefs } from "pinia";
import { CommonStore } from "./store/common-store";
import { ModalResult } from "./js/interface";


import { defineComponent } from "vue";
import ModalGlobal from "./views/modals/modal-global.vue";
import ModalPolicy from "./views/modals/modal-privacy-policy.vue";
import ModalTerm from "./views/modals/modal-term.vue";

const __default__ = defineComponent({
  name: "ClientEstimate",
  components: {
    ModalGlobal,
    ModalPolicy,
    ModalTerm,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const commonStore = CommonStore();
const { isViewLoader, isShowGlobalModal, gModalData, isShowFormModal, isShowPolicyModal, isShowTermModal, cModalComponent } = storeToRefs(commonStore);

const isLoader = ref(false);

watch(isViewLoader, (value, oldValue) => {
  if (value) {
    isLoader.value = true;
  } else {
    setTimeout(() => {
      isLoader.value = false;
    }, 100);
  }
});

const onConfirm = () => {
  const result: ModalResult = {
    modalName: gModalData.value.modalName,
    result: gModalData.value.result,
  };

  commonStore.setModalResult(result);
  commonStore.closeGlobalModal();
};

const onClose = () => {
  commonStore.closeGlobalModal();
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (_unref(isShowFormModal))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(cModalComponent))))
        ]))
      : _createCommentVNode("", true),
    (_unref(isShowPolicyModal))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(ModalPolicy)
        ]))
      : _createCommentVNode("", true),
    (_unref(isShowTermModal))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(ModalTerm)
        ]))
      : _createCommentVNode("", true),
    (_unref(isShowGlobalModal))
      ? (_openBlock(), _createBlock(ModalGlobal, {
          key: 3,
          isShowCancel: _unref(gModalData).isShowCancel,
          onOnCancel: onClose,
          onOnConfirm: onConfirm
        }, {
          title: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(gModalData).title), 1)
          ]),
          description: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_unref(gModalData).content), 1)
          ]),
          _: 1
        }, 8, ["isShowCancel"]))
      : _createCommentVNode("", true),
    (isLoader.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass(["view-loader", !_unref(isViewLoader) ? 'view-loader-hidden' : ''])
        }, _hoisted_6, 2))
      : _createCommentVNode("", true)
  ]))
}
}

})